import { render, staticRenderFns } from "./EditStockistUplineBonusSetting.vue?vue&type=template&id=6f815bff"
import script from "./EditStockistUplineBonusSetting.vue?vue&type=script&lang=js"
export * from "./EditStockistUplineBonusSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports